// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <sub-header header="'Assign to group'"></sub-header>

    <div class="alert">
      <span>
        Please note that in the "assign to" selector you can choose <strong>ONLY</strong> groups that contain the selected customer
        If you cannot find the group you are looking for, add the customer to the group first.
      </span>
    </div>

    <form name="\$ctrl.form">

      <table class="table table--generate-row-ids">
        <tbody>
        <tr>
          <td></td>
          <td>Group name:</td>
          <td>
            <select
              required
              class="form-control"
              ng-model="\$ctrl.request.targetCustomerId"
              ng-change="\$ctrl.updateGroupLoans()"
              ng-options="c.id as c.effectiveName for c in \$ctrl.assignedGroups">
            </select>
          </td>
        </tr>

        <tr>
          <td></td>
          <td>Create new group loan:</td>
          <td>
            <select
              required
              boolean-options
              class="form-control"
              ng-model="\$ctrl.request.newGroupLoan"
              ng-change="\$ctrl.updateGroupLoans()">
            </select>
          </td>
        </tr>

        <tr ng-if="!\$ctrl.request.newGroupLoan">
          <td></td>
          <td>Group loan no:</td>
          <td>
            <select
              required
              class="form-control"
              ng-model="\$ctrl.request.groupLoanId"
              ng-options="o.value as o.label for o in \$ctrl.allowedGroupLoans">
            </select>
            <help title="{{ \$ctrl.getAllowedGroupLoansHelpTitle() }}"></help>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="buttons">
        <button
          class="btn btn-warning"
          ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button
          class="btn btn-success"
          ng-click="\$ctrl.assign()"
          ng-disabled="\$ctrl.form.\$invalid">
          Assign
        </button>
      </div>

    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/assign-group/customer-loans-assign-group.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;